<template>
    <div class="container">
        <div>
      <Header title="List" />
      <div class="content">
      <div class="filters flex justify-center">
       <div class="list flex" @click="listActivated">
       <svg xmlns="http://www.w3.org/2000/svg" width="17" height="12" viewBox="0 0 17 12" fill="none">
<path d="M1 1H16" stroke="rgba(0,0,0,0.5)" :class="{'black-stroke':listActive}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 6.18518H16" stroke="rgba(0,0,0,0.5)" :class="{'black-stroke':listActive}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M1 11H16" stroke="rgba(0,0,0,0.5)" :class="{'black-stroke':listActive}" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
       <div :class="{'black' : listActive}">List</div>
       </div>
       <div class="map flex" @click="mapActivated">
       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="17" height="17" viewBox="0 0 17 17" fill="none">
<rect width="17" height="17" fill="url(#pattern0)" fill-opacity="0.5"/>
<defs>
<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
<use xlink:href="#image0_60_196" transform="scale(0.00444444)"/>
</pattern>
<image id="image0_60_196" width="225" height="225" xlink:href="data:image/png;base64,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"/>
</defs>
</svg>
       <div :class="{'black' : mapActive}" >Map</div>
       </div>
      </div>
      <div class="list-details ">
          <div class="name-and-like flex">
              <div class="name fw-700 black">
                 User’s list name
              </div>
              <div class="like" v-if="!myList">
                  <img src="@/assets/images/like.png" />
              </div>
              <div v-else class="edit-list" @click="editList">
                  Edit
              </div>
          </div>
          <div class="nickname">
              User’s nickname here
          </div>
          <div class="list-explanation">
              List explanation comes here if any, if not, no display. List explanation comes here if any, if not, no display. 
          </div>
          <div class="reviews-and-food-categories flex">
          <div class="total-reviews flex">
           <img src="@/assets/images/listcount.png" class="contained" />
           <div class="review-count">35</div>
       </div>
       <div class="selected-categories flex">
           <img src="@/assets/images/knifeporkspoon.png" class="contained" />
           <div> Selected Food Categories</div>
       </div>
      </div>
       </div>
       
       <div class="resturant-details">
           <div class="resturant" v-for="resturant in totalResturants" :key="resturant">
               <div class="name">
                         Restaurant name here
                    </div>
               <div class="flex rating-and-information">
                <div class="rating"> <p class="white"> 5.0  </p>  </div>
                <div class="flex resturant-content">
                    <div class="icons flex flex-column">
                     <div class="category-icon">  <img src="@/assets/images/knifeporkspoon.png" /></div>
                     <div class="location-icon">  <img src="@/assets/images/location.png" /></div>
                     <div class="comment-icon">  <img src="@/assets/images/comment.png" /></div>
                    </div>
                    <div class="texts flex flex-column">
                        <div class="category-text category-text-and-rating flex">
                            <div>
                            Sushi, Bar, Ramen
                            </div>
                            <div class="flex rating">
                               <img src="@/assets/images/camera.png"> 
                               <div> 35 </div>
                            </div>
                            </div>
                        <div class="location-text">Location here</div>
                        <div class="comment-text">if any comments, display that here...</div>
                    </div>
                </div>
                </div>
           </div>
           <div class="load-more-text" @click="loadMore">
               Load more
           </div>
       </div>

      </div>
      </div>
      <div class="footer">
          <Footer />
      </div>
    </div>
</template>

<script>
import Footer from '../components/Footer.vue'
import Header from '../components/Header.vue'
export default {
components:{ 
    Footer , Header
},

data(){
    return{
        myList: true,
        listActive: true,
        mapActive: false,
        totalResturants: 6,
        loadAllResturants: false
    }
},
 methods:{
        listActivated(){
            this.mapActive = false
            this.listActive = true
        },
        mapActivated(){
            this.listActive = false
            this.mapActive = true
            this.$router.push({name:'Map', params : {listname: 'user list name'}})
        },
    loadMore(){
        this.totalResturants = 40
    },
    editList(){
        this.$router.push({name: 'EditList'})
    }
    }
}
</script>

<style lang="scss" scoped>
.container{
    .footer{
        max-width: 375px;
        margin: auto;
    }
  .top-bar{
        justify-content: space-between;
        align-items: center;
        padding: 12px;
        .open-list-text{
            font-size: 18px;
            font-weight: 500;
        }
        .back-btn , .menu{
            cursor: pointer;
        }
        .changePosition{
            position: fixed;
            top: 20px;
            right: 10px;
        }
    }
    .content{
        max-width: 375px;
        margin: auto;
        background: #fff;
        padding-bottom: 100px;
    .filters{
        padding: 15px;
        gap: 50px;
        .list , .map{
            gap: 20px;
            color: rgba(0,0,0,0.5);
            cursor: pointer;
            align-items: center;
        }
    }
    .list-details{
        padding: 20px;
        background: #ededed;
        .name-and-like{
          justify-content: space-between;
      //    align-items: center;
          .name{
              font-size: 24px;
          }
          .like{
              cursor: pointer;
          }
          .edit-list{
              font-size: 18px;
              color: red;
              cursor: pointer;
          }
        }
                .list-explanation{
                    font-size: 14px;
                    color: #5b5b5b;
                    margin: 10px 0;
                }
                .nickname{
                    color: #5b5b5b;
                    font-size:14px;
                }
                .reviews-and-food-categories{
                    margin-top: 5px;
                    justify-content: space-between;
                    .total-reviews , .selected-categories{
                        gap: 10px;
                        color: #333333;
                        font-size: 14px;
                    }
                }
    }
    .resturant-details{
        padding: 20px;
        .resturant{  
            border-bottom: 1px solid #E3E3E3;
            padding: 10px 0;
            &:first-child{
                padding-top: 0 !important;
            }
             .name{
                   font-size: 18px;
                   color: #333333;
                   margin-bottom: 10px;
                   margin-left: 55px !important;
               }
           .rating-and-information{
               gap: 15px; 
               .rating{
                   p{
                 background: linear-gradient(224.31deg, #F57600 19.14%, #FFB82F 80.17%);
                 padding: 10px;
                 border-radius: 50%;
                   }
               }
          .resturant-content{
              gap:10px;
              .icons{
                  align-items: center;
                  .location-icon , .comment-icon{
                      margin-top: 5px;
                  }
              }
              .texts{
                  color: #838383;
                  font-size: 14px;
                  .category-text-and-rating{
                      justify-content: space-between;
                      .rating{
                          align-items: center;
                          gap: 10px;
                      }
                  }
                  .location-text , .comment-text{
                      margin-top: 5px;
                  }
              }
          }
        }
        }
        .load-more-text{
            text-align: center;
            font-size: 14px;
            color: #7d7d7d;
            padding-top: 20px ;
            cursor: pointer;
        }
    }
    }
}
</style>